import { render, staticRenderFns } from "./vxUnlockingConfirm.vue?vue&type=template&id=12644538&"
import script from "./vxUnlockingConfirm.vue?vue&type=script&lang=js&"
export * from "./vxUnlockingConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12644538')) {
      api.createRecord('12644538', component.options)
    } else {
      api.reload('12644538', component.options)
    }
    module.hot.accept("./vxUnlockingConfirm.vue?vue&type=template&id=12644538&", function () {
      api.rerender('12644538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/dividend/vxUnlockingConfirm.vue"
export default component.exports